import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@storyblok/react/dist/live-editing.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["PhnxButton"] */ "/vercel/path0/src/components/01-atoms/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhnxFooter"] */ "/vercel/path0/src/components/03-organisms/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/03-organisms/Header/Blok.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhnxNotfound"] */ "/vercel/path0/src/components/04-templates/Notfound/Notfound.tsx");
